<app-add-form
  [title]="updatedFormConfig().title"
  [formFields]="updatedFormConfig().formFields"
  [tableSections]="updatedTableSections()"
  [headerActions]="updatedFormConfig().headerActions"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [initialData]="combinedInitialData()"
  [loading]="loading()"
  (formAction)="onFormAction($event)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
>
  <ng-template #actionsTemplate let-rowData>
    <div class="flex gap-2 justify-center">
      @if (isInheritedProperty(rowData.id)) {
        <!-- Inherited properties: only show View button -->
        <p-button
          size="small"
          [label]="'common.actions.view' | translate"
          severity="info"
          (onClick)="onViewProperty(rowData.id)"
          text
        ></p-button>
      } @else if (!viewMode) {
        <!-- Non-inherited properties in edit mode: show Edit and Delete buttons -->
        <p-button
          size="small"
          [label]="'common.actions.edit' | translate"
          severity="info"
          (onClick)="onEditProperty(rowData.id)"
          text
        ></p-button>
        <p-button
          size="small"
          [label]="'common.actions.delete' | translate"
          severity="danger"
          (onClick)="onDeleteProperty(rowData.id)"
          text
        ></p-button>
      } @else {
        <p-button
          size="small"
          [label]="'common.actions.view' | translate"
          severity="info"
          (onClick)="onViewProperty(rowData.id)"
          text
        ></p-button>
      }
    </div>
  </ng-template>
</app-add-form>

<!-- Add Property Dialog -->
<app-property-dialog
  [(visible)]="showAddPropertyDialog"
  (confirm)="onPropertyDialogConfirm($event)"
  [initialData]="editingProperty()"
  [viewMode]="false"
></app-property-dialog>

<!-- View Property Dialog -->
<app-property-dialog
  [(visible)]="showViewPropertyDialog"
  [initialData]="viewingProperty()"
  [viewMode]="true"
></app-property-dialog>

<!-- Toast Messages -->
<p-toast></p-toast>

<!-- Custom Confirmation Dialog -->
<app-confirmation-dialog
  [(visible)]="showConfirmationDialog"
  [message]="confirmationMessage()"
  [buttons]="confirmationButtons()"
  (emitOnClick)="onConfirmationDialogAction($event)"
></app-confirmation-dialog>
